import { useSelector } from "react-redux";
import { RootState } from "../rootReducer";

// Custom hook: name starts with "use"
export const useIsEventOrders = () => {
  const eventSlug = useSelector((state: any) => state.cart.eventDate);
  const eventDate = useSelector((state: any) => state.cart.isEventDate);
  
  return Boolean(eventDate) || Boolean(eventSlug);
};


export const getEventSlug = (state: any) => state.cart.eventDate;
export const getEventDate = (state: any) => state.cart.isEventDate;

export const getLocationSlug = (state: any) => state?.restaurant?.currentRestaurantDetail?.locationSlug;